export function mapEnumToItem(
  enumObject: Record<string, string>,
  translationKey: string
) {
  return Object.values(enumObject).map((value) => ({
    text: `${translationKey}.${value}`,
    value,
  }));
}
